import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, retry, throwError, timer } from 'rxjs';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry({
      count: 2,
      delay: (error, retryCount) => {
        // Only retry on network errors or 5xx server errors
        if (error instanceof HttpErrorResponse) {
          if (error.status === 0 || (error.status >= 500 && error.status < 600)) {
            return timer(retryCount * 1000);
          }
        }
        throw error; // Don't retry other errors
      },
    }),
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unexpected error occurred';

      if (error.status === 0) {
        errorMessage = 'Unable to connect to server. Please check your internet connection.';
      } else if (error.status === 404) {
        errorMessage = 'The requested resource was not found.';
      } else if (error.status === 403) {
        errorMessage = 'You do not have permission to access this resource.';
      } else if (error.status >= 500) {
        errorMessage = 'Server error. Please try again later.';
      }

      console.error('[API Error]', {
        url: req.url,
        status: error.status,
        message: error.message,
      });

      return throwError(() => new ApiError(errorMessage, error.status));
    }),
  );
};
